import { inject } from '@angular/core';
import { APP_CONFIG } from '../tokens/app-config.token';
import type { Environment } from '../../../environments/environment.interface';

export const getConstants = (appConfig: Environment) => ({
    DATANYZE_COOKIE_DOMAIN: '.datanyze.com',
    COOKIE_TOKEN: appConfig.auth_cookie,
    COOKIE_DEVICE_ID: appConfig.deviceId_cookie,
    COOKIE_VERIFICATION_ID: appConfig.verification_id_cookie,
    GOOGLE_ANALYTIC_SECTION: 'website',
    SF_CAMP_ID: 'camp_id',
    REDIRECT_KEY: 'redirect',
    SKIPCAPTCHA_KEY: 'skipcaptcha',
    GA_COOKIE_FETCH_RETRIES: 3,
    GTM_COOKIE_NAME: '_ga',
    GA_COOKIE_FETCH_INTERVAL: 2000,
    GOOGLE_OPTIMIZE_SCRIPT: 'https://www.googleoptimize.com/optimize.js?id=OPT-K5F7LKW',
    COOKIE_CONSENT_COOKIE_NAME: 'CookieConsent',
    RANDOM_ID_KEY: 'user-session-id',
  });

// For backward compatibility - deprecated, use getConstants() instead
export default {
  DATANYZE_COOKIE_DOMAIN: '.datanyze.com',
  COOKIE_TOKEN: '',
  COOKIE_DEVICE_ID: '',
  COOKIE_VERIFICATION_ID: '',
  GOOGLE_ANALYTIC_SECTION: 'website',
  SF_CAMP_ID: 'camp_id',
  REDIRECT_KEY: 'redirect',
  SKIPCAPTCHA_KEY: 'skipcaptcha',
  GA_COOKIE_FETCH_RETRIES: 3,
  GTM_COOKIE_NAME: '_ga',
  GA_COOKIE_FETCH_INTERVAL: 2000,
  GOOGLE_OPTIMIZE_SCRIPT: 'https://www.googleoptimize.com/optimize.js?id=OPT-K5F7LKW',
  COOKIE_CONSENT_COOKIE_NAME: 'CookieConsent',
};
